import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { OCRScopingJobsRootContainer } from './OCRScopingJobsRootContainer'

export default observer(function OCRScopingJobsContainer() {
  const { internal } = useFeatures(({ jobs }) => ({
    internal: jobs.internal(),
  }))
  return <OCRScopingJobsRootContainer vm={internal.ocrScopingJobsViewModel} />
})
